import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=9238e23a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=9238e23a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9238e23a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9238e23a')) {
      api.createRecord('9238e23a', component.options)
    } else {
      api.reload('9238e23a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=9238e23a&scoped=true&", function () {
      api.rerender('9238e23a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bbVom5RKRK9u/JS/comp/PopupBox.vue"
export default component.exports